






































import { Vue, Prop, Component } from 'vue-property-decorator';
import { InputValidation } from '../../../helpers/inputValidation';
import CountryService from 'services/CountryService';
import { Country } from '@models';

@Component
export default class CountrySelector extends Vue {
  name = 'country-selector';

  @Prop(String) id!: string;
  @Prop(Function) onError: any;

  @Prop({ type: Object as () => Country }) value: Country;

  countries: Country[] = [];

  options: Country[] = [];
  isLoading: boolean = false;
  optionsMax: number = 249;

  input = InputValidation;


  onSelectionMenuClosed(value, id) {
    const rules = this.$refs.inputComponent.rules;
    this.$refs.inputComponent.validate(rules);
  }

  bindValue() {
    if (this.value == undefined) {
      let lastSavedCountryIsoCode = localStorage.getItem("LastSavedCountryIsoCode");
      if (lastSavedCountryIsoCode) {
        var lastSavedCountry = this.options.find(c => c.isoCode === lastSavedCountryIsoCode);
        this.updateValue(lastSavedCountry);
      }
    }

    return this.value;
  }

  updateValue(value: Country) {
    this.$emit('input', value)
  }

  created() {
    this.loadCountries();
  }

  loadCountries(){
    CountryService.getCountries().then(response => {
            this.countries = response.data;
            this.options = this.countries;
          });
  }

  asyncFindCountries(query) {
      this.isLoading = true;
      this.options = this.countries.filter(c => c.name.toLowerCase().includes(query.toLowerCase()));
      this.isLoading = false;
  }

  countryFilterTaglimitText(count) {
    return `and ${count} other items`
  }
  
}
